export const hasBillingInfo = (organization: {
  org_number?: string | null
  billing_email?: string | null
  billing_address_line1?: string | null
  billing_city?: string | null
}): boolean => {
  return !!(
    organization.org_number ||
    organization.billing_email ||
    organization.billing_address_line1 ||
    organization.billing_city
  )
}
